import React from 'react';

export type AdminDashboardTile = {
  id: string;
  title: string;
  value: string;
  subtitle?: string;
};

interface AdminDashboardScreenProps {
  isDarkMode: boolean;
  tiles: AdminDashboardTile[];
};

const AdminDashboardScreen: React.FC<AdminDashboardScreenProps> = ({ isDarkMode, tiles }) => {
  const palette = ['#3B82F6', '#16A34A', '#F59E0B', '#EF4444'];
  const footerBg = isDarkMode ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.10)';

  return (
    <div
      id="admin-dashboard"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: 16,
      }}
    >
      {tiles.map((t, idx) => {
        const bg = palette[idx % palette.length];
        return (
          <div
            key={t.id}
            id={`admin-tile-${t.id}`}
            style={{
              borderRadius: 10,
              overflow: 'hidden',
              backgroundColor: bg,
              color: '#FFFFFF',
              position: 'relative',
              minHeight: 130,
            }}
          >
            <div
              style={{
                position: 'absolute',
                right: -18,
                top: -18,
                width: 110,
                height: 110,
                borderRadius: 999,
                backgroundColor: 'rgba(255,255,255,0.18)',
              }}
            />

            <div style={{ padding: 16, boxSizing: 'border-box' }}>
              <div id={`admin-tile-${t.id}-value`} style={{ fontSize: 34, fontWeight: 900, lineHeight: 1.05 }}>
                {t.value}
              </div>
              <div id={`admin-tile-${t.id}-title`} style={{ marginTop: 8, fontSize: 14, fontWeight: 700 }}>
                {t.title}
              </div>
            </div>

            <div
              id={`admin-tile-${t.id}-footer`}
              style={{
                padding: '10px 16px',
                boxSizing: 'border-box',
                backgroundColor: footerBg,
                fontSize: 13,
                fontWeight: 700,
                textAlign: 'center',
              }}
            >
              {t.subtitle ?? 'More info'}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AdminDashboardScreen;
